<template>
  <div id="footer">
    <div class="h-8 bg-gray-900">
      <div class="container">
        <div id="left">
          &copy;2020 Southern Union State Community College
        </div>
        <div id="center">
        </div>
        <div id="right">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
#footer {
  background-color: #ddd;
  padding: 12px 0;
}
</style>